/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { BannerId } from 'cio/components/billing/current-plans';
import { inject as service } from '@ember/service';
import BillingService from 'cio/services/billing';

interface CurrentPlanDescriptionWithText {
  title: string;
  value: string;
  details: string;
}

interface CurrentPlanDescriptionWithLink {
  title: string;
  value: string;
  detailsLink: {
    text: string;
    url: string;
  };
}

export type CurrentPlanDescriptionItem = CurrentPlanDescriptionWithText | CurrentPlanDescriptionWithLink;

export interface CurrentPlanUsageItem {
  title: string;
  description?: string;
  details: string;
  percentage: number;
}

export interface CurrentPlanBanner {
  type: CurrentPlanBannerType;
  highlight: string;
  text: string;
}

interface CurrentPlanCardArgs {
  title: string;
  iconSrc: string;
  descriptionItems: CurrentPlanDescriptionItem[];
  usageItems?: CurrentPlanUsageItem[];
  banner?: CurrentPlanBanner;
  suspendTrialAt: number;
  trialExpired: boolean;
  isTrial: boolean;
  trackLimitsBannerButtonClick: (bannerId: BannerId) => void;
}

type CurrentPlanBannerType = 'limit-exceeded' | 'not-current-product';

export default class CurrentPlanCard extends Component<CurrentPlanCardArgs> {
  @service billing!: BillingService;
  get usageItems() {
    return this.args.usageItems?.map((item) => ({
      ...item,
      style: `width: ${item.percentage}%;`,
    }));
  }

  get isLimitBanner() {
    return this.args.banner?.type === 'limit-exceeded';
  }

  get showTrialLabel() {
    return this.args.isTrial && this.args.suspendTrialAt > 0;
  }
}
